import { Card } from '@/components';
import { FC } from 'react';
import YieldBearingAssetPerformanceDetailCardBody from './YieldBearingAssetPerformanceDetailCardBody';
import YieldBearingAssetPerformanceDetailCardHeader from './YieldBearingAssetPerformanceDetailCardHeader';
interface Props {
  ticker: string;
  className?: string;
}
const YieldBearingAssetPerformanceDetailCard: FC<Props> = ({
  ticker,
  className,
}) => {
  return (
    <Card className={className}>
      <YieldBearingAssetPerformanceDetailCardHeader ticker={ticker} />
      <YieldBearingAssetPerformanceDetailCardBody ticker={ticker} />
    </Card>
  );
};
export default YieldBearingAssetPerformanceDetailCard;
